import { create } from "zustand";
import { persist } from "zustand/middleware";

// Date-display preference. Kept SEPARATE from useLocaleStore (which drives the
// calendar picker). "AD" = Gregorian, "BS" = Bikram Sambat (Nepali) rendered
// with romanized month names (e.g. "Mangsir 29, 2081").
export type DateFormatPref = "AD" | "BS";

interface DateDisplayState {
  dateFormat: DateFormatPref;
  setDateFormat: (dateFormat: DateFormatPref) => void;
  toggleDateFormat: () => void;
}

export const useDateDisplayStore = create<DateDisplayState>()(
  persist(
    (set, get) => ({
      dateFormat: "AD",
      setDateFormat: (dateFormat) => set({ dateFormat }),
      toggleDateFormat: () =>
        set({ dateFormat: get().dateFormat === "AD" ? "BS" : "AD" }),
    }),
    {
      name: "date-display-store", // key in localStorage
    },
  ),
);
